import { LANGUAGE_UPDATE } from '../actionTypes'

import { getInitialLanguage } from '../../Modules/language'

export default (state = getInitialLanguage(), action) => {
    switch (action.type) {
        case LANGUAGE_UPDATE: {
            const { language } = action.payload
            localStorage.setItem('language', language)
            return language
        }

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/language.js